import { useGetPreAnalyticData } from '@BUP/hooks/Sociogram/preAnalyticData/useGetPreAnalyticData'
import { useSociogramActions } from '@BUP/hooks/Sociogram/useSociogramContext'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { monitorException } from '@BUP/services/monitor'
import NoResultsMessage from './no-results-message'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '../../Alert'
import ButtonComponent from '../../Button'
import styles from './inner-table.module.scss'
import { Tooltip } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'

const ResultsButton = ({ isMultiCourse, survey, surveyName }) => {
  const history = useHistory()
  const i18n = useTranslation()
  const { results, id: surveyId } = survey
  const { setSelectedSurvey } = useSociogramActions()

  const {
    isLoadingPreAnalyticData,
    preAnalyticData,
    errorPreAnalyticData,
    reloadPreAnalyticData
  } = useGetPreAnalyticData(surveyId)

  const hasPreAnalyticData = Array.isArray(preAnalyticData) && preAnalyticData.length > 0

  if (isLoadingPreAnalyticData) return <BupSpinner size='small' />

  if (!hasPreAnalyticData && !errorPreAnalyticData) {
    return (
      <AlertComponent message={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.resultsButton.progressMessage')}`} type='info' />
    )
  }

  if (errorPreAnalyticData) {
    const isTimeoutError =
      errorPreAnalyticData.code === 'ECONNABORTED' ||
      errorPreAnalyticData.message?.includes('timeout')

    // Registrar error en monitor
    const errorMessage = errorPreAnalyticData.data
    const error = new Error(
      `Error in preAnalyticData request, /surveys-pre-analityc-formats?surveyId=${surveyId}`,
      { cause: errorPreAnalyticData }
    )
    monitorException(error, { extra: errorMessage })

    const shouldRenderReloadButton = isTimeoutError && !hasPreAnalyticData

    return (
      <div className='noResultsMessage'>
        {shouldRenderReloadButton
          ? (
            <Tooltip
              title={`${i18n.t('pages.data.sociogram.activeSociogramEce.timeoutError')}`}
              placement='top'
            >
              <span style={{ display: 'inline-block' }}>
                <ButtonComponent
                  buttonText={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.resultsButton.name')}`}
                  icon={<ReloadOutlined />}
                  size='small'
                  colorType='tertiary'
                  onClick={() => reloadPreAnalyticData()}
                />
              </span>
            </Tooltip>
            )
          : (
            <NoResultsMessage surveyId={surveyId} />
            )}
      </div>
    )
  }

  const handleViewCourseResult = async (results, survey, surveyName) => {
    const resultsCourse = isMultiCourse ? results : results[0]
    setSelectedSurvey(survey)
    const surveyId = survey.id
    history.push({
      pathname: `/sociogram/dashboard/${surveyId}`,
      result: resultsCourse,
      survey,
      courseName: surveyName,
      preAnalyticData
    })
  }

  return (
    <div className={styles.results_button_wrapper}>
      <ButtonComponent
        buttonText={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.resultsButton.name')}`}
        colorType='secondary'
        block
        bold={false}
        onClick={() => handleViewCourseResult(results, survey, surveyName)}
      />
    </div>
  )
}

export default ResultsButton
